<template>
  <div class="xinsheng-warp system-warp">
    <FilterForm
      :formData="filterData"
      :filters="filters"
      @submit="handleFilterSubmit"
      @reset="handleReset"
    />
<!--    <div class="system-btn user-btn">-->
<!--      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleNew"-->
<!--        >添加角色</el-button-->
<!--      >-->
<!--      <el-button size="small" @click="batchDelete">删 除</el-button>-->
<!--    </div>-->
    <div class="container">
      <div class="right">
        <RoleTable
          v-if="tableData"
          :tableColumn="tableColumn"
          :tableData="tableData"
          :selection="true"
          :numIndex="true"
          numWidth="100px"
          @selection="handleSelectionChange"
          @edit="goToEdit"
          @delete="goToDelete"
          @view="goToView"
          @setting="handleSetting"
          @dataSetting="handleDataSetting"
        />
        <RolePagination
          :total="total"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
        />
      </div>
    </div>
    <RoleDialog
      :title="title"
      :isShowDialog="isShowDialog"
      :rules="rules"
      :forms="forms"
      :formData="formData"
      :width="500"
      @submit="handleSubmit"
      @close="handleColse"
    />
  </div>
</template>

<script>
import FilterForm from "@/components/filter";
import { computed, onMounted, reactive, ref } from "vue";
import { ElButton, ElInput, ElMessage, ElTree } from "element-plus";
import { tableColumn, forms } from "./index.js";
import RoleTable from "@/components/table";
import RolePagination from "@/components/pagination";
import RoleDialog from "@/components/dialog-form";
import { useStore } from "vuex";
import { putChannel } from "@/api/method/channel";
import { reset } from "@/until";

export default {
  name: "SystemRole",
  components: {
    FilterForm,
    [ElButton.name]: ElButton,
    [ElInput.name]: ElInput,
    [ElTree.name]: ElTree,
    RoleTable,
    RolePagination,
    RoleDialog
  },
  setup() {
    const { dispatch, state } = useStore();
    const filterData = reactive({
      search: null,
    });
    const formData = reactive({
      name: null,
      probability: null,
      description: null,
    });

    const filters = reactive([
      [
        {
          label: "渠道名称",
          type: "input",
          attr: "search",
          placeholder: "搜索渠道名称",
          suffixIcon: "el-icon-search",
          column: 8,
          labelWidth: "80px",
        },
        {
          type: "button",
          column: 4,
        },
      ],
    ]);

    const pagination = reactive({
      page: 1,
      size: 10,
    });

    const company = ref("");
    const tableData = computed(() => state.channelPageList && state.channelPageList.records);
    const total = computed(() => state.channelPageList && state.channelPageList.total);
    console.log(state.channelPageList)

    const isShowDialog = ref(false);
    const title = ref("添加");

    const handleNew = () => {
      isShowDialog.value = true;
    };
    const handleColse = () => {
      isShowDialog.value = false;
      reset(formData);
      formData.type = 1;
    };

    const getList = () => {
      dispatch("channelPageList", { ...pagination, ...filterData });
    };

    const currentChange = (page) => {
      pagination.page = page;
      getList();
    };
    const sizeChange = (size) => {
      pagination.size = size;
      getList();
    };

    onMounted(() => {
      getList();
    });
    const idArr = ref([]);
    const handleSelectionChange = (arr) => {
      idArr.value = arr.map((item) => item.id);
    };

    const isSetting = ref(false);
    const isDataSetting = ref(false);
    const defaultSelectKeys = ref([]);
    const treeRef = ref(null);
    const handleRoleClose = () => (isSetting.value = false);

    const handleNodeClick = () => {};
    const rules = reactive({
      name: [{ required: true, message: "请输入渠道名", trigger: "submit" }],
    });

    const handleSubmit = async () => {
      const { id, ...params } = formData;
      if (id) {
        const res = await putChannel({ id, ...params });
        if (res.code == 200) {
          ElMessage.success("编辑成功！");
          handleColse();
          getList();
        } else {
          ElMessage.error(res.msg);
        }
      }
    };

    const getRoleDetail = (id) => {
      const { name, probability, description } = state.channelDetail;
      formData.id = id;
      formData.probability = probability;
      formData.name = name;
      formData.description = description;
    };
    const goToEdit = async (id) => {
      isShowDialog.value = true;
      title.value = "编辑";
      await dispatch("channelDetail", id);
      getRoleDetail(id);
    };

    const isShowView = ref(false);

    const handleViewColse = () => {
      isShowView.value = false;
      reset(formData);
      formData.type = 1;
    };

    const handleFilterSubmit = () => getList();
    const handleReset = () => {
      reset(filterData);
      getList();
    };


    return {
      filters,
      filterData,
      company,
      tableColumn,
      tableData,
      handleNew,
      isShowDialog,
      rules,
      forms,
      formData,
      total,
      handleSelectionChange,
      handleNodeClick,
      handleSubmit,
      handleColse,
      title,
      goToEdit,
      handleViewColse,
      isShowView,
      isSetting,
      isDataSetting,
      defaultSelectKeys,
      treeRef,
      handleRoleClose,
      handleFilterSubmit,
      handleReset,
      currentChange,
      sizeChange,
    };
  },
};
</script>

<style lang="scss" scoped>
.user-btn {
  padding-bottom: 40px;
}
.container {
  display: flex;
  height: auto;
  .left {
    width: 250px;
    background: #f5f6f9;
    margin-right: 24px;
    padding: 20px;
  }
  .right {
    flex: 1;
    background-color: #fff;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.company-block {
  margin-bottom: 20px;
}

.company-block .el-input__inner {
  background: white !important;
}
.depart-tree {
  background: #f5f6f9;
  .el-tree-node__content {
    background: #f5f6f9;
  }
}
</style>
